'use client';

import { useAppContext } from '@ifixit/app/hooks';
import { useMemo } from 'react';
import { IFixitAPIClient } from '.';

type UseIFixitApiClientProps = {
   disableCacheGets: boolean;
   headers?: Record<string, string>;
};

export function useBaseIFixitApiClient({ disableCacheGets, headers }: UseIFixitApiClientProps) {
   const { ifixitOrigin } = useAppContext();

   const headersKey = JSON.stringify(headers);
   const stableHeaders = useMemo(() => headers, [headersKey]);
   const client = useMemo(
      () =>
         new IFixitAPIClient({
            disableCacheGets,
            origin: ifixitOrigin,
            headers: stableHeaders,
         }),
      [disableCacheGets, ifixitOrigin, stableHeaders]
   );

   return client;
}

export function useIFixitApiClient() {
   const search = typeof window === 'undefined' ? '' : window.location.search;
   const disableCacheGets = new URLSearchParams(search).has('disableCacheGets');
   return useBaseIFixitApiClient({ disableCacheGets });
}
